import { ICON_COLOR } from '@zep-us/zus';
import { QuestionmarkSmallCircleIcon } from '@/icons/components';
import { cn } from '@/utils/tailwind.util';
import { Tooltip } from '../../components/ui/Tooltip';
type QuestionTooltipProps = {
  content: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
  tooltipClassName?: string;
};
export const QuestionTooltip = ({
  content,
  side = 'top',
  align = 'center',
  tooltipClassName
}: QuestionTooltipProps) => {
  return <Tooltip side={side} align={align} trigger={<span className="inline-flex cursor-pointer">
          <QuestionmarkSmallCircleIcon size={'xs'} fill={ICON_COLOR.alternative} />
        </span>} arrow={{
    fill: 'white'
  }} className={cn('max-w-[300px] bg-default text-body-sm-semibold text-default', tooltipClassName)} content={content} data-sentry-element="Tooltip" data-sentry-component="QuestionTooltip" data-sentry-source-file="QuestionTooltip.tsx" />;
};